<app-notification #notification [hidden]="!notification?.isShow" class="w-100 mb-4"></app-notification>
<mat-table [dataSource]="accessPermissions.requests">
  <ng-container matColumnDef="clientName">
    <mat-header-cell *matHeaderCellDef class="mx-1 td-clientName">{{ 'client' | transloco }}</mat-header-cell>
    <mat-cell *matCellDef="let element" class="mx-1 td-clientName">{{ getClientName(element) }}</mat-cell>
  </ng-container>

  <ng-container matColumnDef="roleName">
    <mat-header-cell class="mx-1 td-roleName" *matHeaderCellDef>{{ 'profileStrangers.role' | transloco }}</mat-header-cell>
    <mat-cell *matCellDef="let element" class="mx-2 td-roleName">{{ getRoleName(element) }}</mat-cell>
  </ng-container>

  <ng-container matColumnDef="registrationRequest">
    <mat-header-cell class="mx-1 td-roleName" *matHeaderCellDef>{{ 'profileStrangers.registrationRequest' | transloco }}</mat-header-cell>
    <mat-cell *matCellDef="let element" class="mx-2 td-roleName">
      <a *ngIf="element.requestNumber" class="link" (click)="getRequestData(element)">{{ 'profileStrangers.registrationRequest' | transloco }} {{ 'number' | transloco }} {{ element.requestNumber}} {{ 'profileStrangers.dated' | transloco }} {{ element.requestedAt | date: 'dd.MM.YYYY HH:mm' }}</a>
      <span ></span>
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="status">
    <mat-header-cell class="mx-1 td-status" *matHeaderCellDef>{{ 'historyStatus.status' | transloco }}</mat-header-cell>
    <mat-cell *matCellDef="let element" class="mx-1 td-status">
      <span class="status">
        <mat-icon
          [class]="getStatusIcon(element)"
        ></mat-icon>
         {{ getStatusName(element) }}
      </span>
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="actions">
    <mat-header-cell *matHeaderCellDef>{{ 'profileStrangers.actions' | transloco }}</mat-header-cell>
    <mat-cell *matCellDef="let element" class="mx-1 td-actions">
      <button
        (click)="requestAccessRights(element)"
        class="primary xs py-1 px-2"
        disableRipple
        *ngIf="!element.requestNumber && userInfo && userInfo.isEmailConfirmed && userInfo.isPhoneConfirmed"
        data-test="stranger-permissions_btn-request-access-rights">
        <svg-icon key="addSmall" class="s"></svg-icon>
        {{ 'profileStrangers.RequestAccessRights' | transloco }}
      </button>
    </mat-cell>
  </ng-container>

  <mat-header-row class="mat-header-row-sticky row-min-width" *matHeaderRowDef="displayedColumns"></mat-header-row>
  <mat-row class="row-min-width" *matRowDef="let row; columns: displayedColumns"></mat-row>
</mat-table>



